import * as types from './home.types';
import * as constants from './home.constants';
import { IMeeting } from '../../resource/meeting/meeting.types';

export const initialHomePage = (): types.IInitialHomePage => ({
  type: constants.INITIAL_HOME_PAGE,
});

export const initialBoardsForMeeting = (meetingId: IMeeting['id']): types.IInitialBoardsForMeeting => ({
  type: constants.INITIAL_BOARDS_FOR_MEETING,
  payload: {
    meetingId,
  },
});
